(() => {
  'use strict';
  const config = window.Trikolumo || {};
  const route = config.routes || {};
  const money = cents => new Intl.NumberFormat('en-US', {style: 'currency', currency: config.currency || 'USD'}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const cartPath = route.cart || '/cart';
  const drawer = document.getElementById('tl-cart-drawer');
  let lastCartButton;
  let cartBusy = false;
  const cartImage = (source, width) => {
    try {
      const url = new URL(source, location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      if (url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/')) url.searchParams.set('width', String(width));
      return url.href;
    } catch (_) { return ''; }
  };
  const setCartBusy = busy => {
    if (busy === cartBusy) return;
    cartBusy = busy;
    if (!drawer) return;
    drawer.setAttribute('aria-busy', String(busy));
    drawer.querySelectorAll('[data-cart-change], [data-cart-input], [name="checkout"]').forEach(control => {
      if (busy) {
        control.dataset.cartWasDisabled = String(control.disabled);
        control.disabled = true;
      } else if ('cartWasDisabled' in control.dataset) {
        control.disabled = control.dataset.cartWasDisabled === 'true';
        delete control.dataset.cartWasDisabled;
      }
    });
  };
  const cartError = message => {
    const box = document.querySelector('[data-cart-error]');
    if (box) {box.textContent = message; box.hidden = false;}
  };
  const paintCart = cart => {
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent = cart.item_count; el.hidden = cart.item_count === 0;});
    document.dispatchEvent(new CustomEvent('trikolumo:cart-painted',{detail:cart}));
    const body = document.querySelector('[data-cart-body]');
    if (!body) return;
    const footer = document.querySelector('[data-cart-footer]');
    if (!cart.item_count) {
      body.innerHTML = '<div class="tl-empty-cart"><p>Your cart is empty.</p><a class="tl-button" href="'+escape(config.productUrl || '/products/hooplume')+'">Personalize Your Mirror</a></div>';
      footer.hidden = true;
      return;
    }
    footer.hidden = false;
    document.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    body.innerHTML = cart.items.map(item => {
      const props = Object.entries(item.properties || {}).filter(([key,value]) => value && !key.startsWith('_')).map(([key,value]) => '<div><strong>'+escape(key)+':</strong> '+escape(value)+'</div>').join('');
      const image = item.featured_image?.url || item.image;
      const thumb = image && cartImage(image, 152);
      const retina = image && cartImage(image, 228);
      return '<article class="tl-cart-line">'+(thumb?'<a href="'+escape(item.url)+'"><img src="'+escape(thumb)+'" srcset="'+escape(thumb)+' 152w, '+escape(retina)+' 228w" sizes="76px" decoding="async" alt="'+escape(item.featured_image?.alt || item.product_title)+'" width="76" height="76"></a>':'<span></span>')+'<div><a class="tl-cart-title" href="'+escape(item.url)+'">'+escape(item.product_title)+'</a><p class="tl-cart-meta">'+escape(item.variant_title === 'Default Title' ? '' : item.variant_title)+'</p><div class="tl-cart-properties">'+props+'</div><div class="tl-quantity"><button type="button" data-cart-change="'+escape(item.key)+'" data-quantity="'+Math.max(0,item.quantity-1)+'" aria-label="Decrease quantity">−</button><input value="'+item.quantity+'" aria-label="Quantity" type="number" min="0" max="99" data-cart-input="'+escape(item.key)+'" data-current-quantity="'+item.quantity+'"><button type="button" data-cart-change="'+escape(item.key)+'" data-quantity="'+(item.quantity+1)+'" aria-label="Increase quantity"'+(item.quantity >= 99 ? ' disabled' : '')+'>+</button></div><button class="tl-cart-remove" type="button" data-cart-change="'+escape(item.key)+'" data-quantity="0">Remove</button></div><div class="tl-cart-line-end">'+money(item.final_line_price)+'</div></article>';
    }).join('');
  };
  const loadCart = async () => {
    setCartBusy(true);
    const errorBox = document.querySelector('[data-cart-error]'); if (errorBox) errorBox.hidden = true;
    try {
      const response = await fetch(cartPath + '.js', {headers: {'Accept':'application/json'}, credentials:'same-origin'});
      if (!response.ok) throw new Error('We couldn\'t load your cart. Please try again.');
      const cart = await response.json(); paintCart(cart); return cart;
    } finally {setCartBusy(false);}
  };
  const openCart = async origin => {
    lastCartButton = origin || document.activeElement;
    if (!drawer?.showModal) {location.href = cartPath; return;}
    if (!drawer.open) drawer.showModal();
    document.body.style.overflow = 'hidden';
    if (cartBusy) return;
    try {await loadCart();} catch (error) {cartError(error.message); const cartFooter = document.querySelector('[data-cart-footer]'); if (cartFooter) cartFooter.hidden = true;const cartBody = document.querySelector('[data-cart-body]'); if(cartBody) cartBody.innerHTML = '<div class="tl-empty-cart"><a class="tl-button" href="'+escape(cartPath)+'">Open cart</a></div>';}
  };
  document.querySelectorAll('[data-cart-open]').forEach(button => button.addEventListener('click', event => {event.preventDefault(); openCart(button);}));
  document.querySelector('[data-cart-close]')?.addEventListener('click', () => drawer.close());
  drawer?.addEventListener('close', () => {document.body.style.overflow = ''; lastCartButton?.focus();});
  drawer?.addEventListener('click', event => {if (event.target === drawer) {const box = drawer.getBoundingClientRect(); if(event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) drawer.close();}});
  const changeCart = async (key, quantity) => {
    if (!key || !Number.isInteger(quantity) || quantity < 0 || quantity > 99 || cartBusy) return;
    setCartBusy(true);
    const errorBox = document.querySelector('[data-cart-error]'); if (errorBox) errorBox.hidden = true;
    try {
      const response = await fetch((route.change || cartPath + '/change') + '.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key,quantity})});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'We couldn\'t update the quantity. Please try again.');
      paintCart(data);
    } catch(error) {
      drawer?.querySelectorAll('[data-cart-input]').forEach(input => {input.value = input.dataset.currentQuantity;});
      try {await loadCart();} catch (_) {
        const footer = document.querySelector('[data-cart-footer]'); if (footer) footer.hidden = true;
      }
      cartError(error.message);
    } finally {setCartBusy(false);}
  };
  drawer?.addEventListener('submit', event => {if (cartBusy) event.preventDefault();});
  drawer?.addEventListener('click', event => {const button = event.target.closest('[data-cart-change]'); if(button) changeCart(button.dataset.cartChange,Number(button.dataset.quantity));});
  drawer?.addEventListener('change', event => {const input = event.target.closest('[data-cart-input]'); if(input) {const raw = input.value.trim(); const n = Number(raw); if(raw !== '' && Number.isInteger(n) && n>=0 && n<=99) changeCart(input.dataset.cartInput,n); else input.value = input.dataset.currentQuantity;}});
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  menuButton?.addEventListener('click', () => {const open = menuButton.getAttribute('aria-expanded') !== 'true'; menuButton.setAttribute('aria-expanded',String(open)); mobileMenu.hidden = !open;});
  document.querySelectorAll('[data-gallery]').forEach(gallery => {
    const track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    const slides = [...track.children];
    const pendingImages = new Map();
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const conserveData = connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    let index = 0;
    const clamp = value => Math.max(0, Math.min(slides.length - 1, value));
    const hydrate = (value, priority = 'auto') => {
      const slide = slides[value];
      if (!slide) return;
      if (pendingImages.has(value)) {
        const pending = pendingImages.get(value);
        if (priority === 'high') pending.fetchPriority = priority;
        return pending;
      }
      const template = slide.querySelector('template[data-gallery-media]');
      if (!template) return slide.querySelector('img');
      const image = template.content.querySelector('img')?.cloneNode(true);
      if (!image) return;
      const placeholder = slide.querySelector('[data-gallery-placeholder]');
      image.loading = 'eager';
      image.fetchPriority = priority;
      image.decoding = 'async';
      image.setAttribute('aria-hidden', 'true');
      image.style.cssText = 'position:absolute;inset:0;opacity:0';
      pendingImages.set(value, image);
      const reveal = () => {
        const decoded = image.decode ? image.decode().catch(() => {}) : Promise.resolve();
        decoded.then(() => {
          if (!image.naturalWidth) return;
          image.style.opacity = '1';
          image.removeAttribute('aria-hidden');
          placeholder?.remove();
          template.remove();
          pendingImages.delete(value);
        });
      };
      image.addEventListener('load', reveal, {once:true});
      image.addEventListener('error', () => {
        // Keep the usable thumbnail and allow the next interaction to retry.
        pendingImages.delete(value);
        image.remove();
      }, {once:true});
      slide.append(image);
      if (image.complete && image.naturalWidth) reveal();
      return image;
    };
    const warmAdjacent = value => {
      hydrate(value - 1, 'low');
      hydrate(value + 1, 'low');
    };
    const activate = value => {
      index = clamp(value);
      gallery.querySelectorAll('[data-gallery-to]').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.galleryTo) === index)));
    };
    const move = value => {
      const target = clamp(value);
      hydrate(target, 'high');
      if (!conserveData) warmAdjacent(target);
      track.scrollTo({left:track.clientWidth * target, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      activate(target);
    };
    gallery.querySelectorAll('[data-gallery-to]').forEach(button => {
      const prepare = () => hydrate(Number(button.dataset.galleryTo), 'high');
      button.addEventListener('pointerenter', prepare);
      button.addEventListener('focus', prepare);
      button.addEventListener('click', () => move(Number(button.dataset.galleryTo)));
    });
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    previous?.addEventListener('click', () => move(index - 1));
    next?.addEventListener('click', () => move(index + 1));
    previous?.addEventListener('pointerenter', () => hydrate(index - 1, 'high'));
    next?.addEventListener('pointerenter', () => hydrate(index + 1, 'high'));
    track.addEventListener('pointerdown', () => warmAdjacent(index), {passive:true});
    let scheduled;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(scheduled);
      scheduled = requestAnimationFrame(() => {
        if (!track.clientWidth) return;
        const position = track.scrollLeft / track.clientWidth;
        hydrate(Math.floor(position));
        hydrate(Math.ceil(position));
        activate(Math.round(position));
      });
    }, {passive:true});
    const hero = slides[0]?.querySelector('img');
    const prepareNext = () => {
      // The main image finishes first; only one neighbour is warmed on normal connections.
      if (!conserveData) hydrate(1, 'low');
    };
    if (hero?.complete && hero.naturalWidth) prepareNext();
    else hero?.addEventListener('load', prepareNext, {once:true});
    activate(0);
  });
  document.querySelectorAll('[data-personalized-form]').forEach(form => {
    const name = form.querySelector('[name="properties[Name]"]');
    const number = form.querySelector('[name="properties[Number]"]');
    const quantity = form.querySelector('[name="quantity"]');
    const button = form.querySelector('[data-add-button]');
    const error = form.querySelector('[data-form-error]');
    const variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    let busy = false;
    let variant = variants.find(item => item.id === Number(form.querySelector('[name="id"]:checked')?.value)) || variants[0];
    const validName = () => name.value.trim().length > 0 && name.value.trim().length <= 12;
    const validNumber = () => /^\d{1,2}$/.test(number.value.trim()) && Number(number.value.trim()) >= 0 && Number(number.value.trim()) <= 99;
    const validQuantity = () => Number.isInteger(Number(quantity.value)) && Number(quantity.value) >= 1 && Number(quantity.value) <= 99;
    const validate = () => {button.disabled = busy || !variant?.available; button.textContent = busy ? 'Adding…' : !variant?.available ? (document.querySelector('[data-ship-block]') ? 'Not available in your country' : 'Currently unavailable') : 'Add to Cart';};
    const changeVariant = () => {
      variant = variants.find(item => item.id === Number(form.querySelector('[name="id"]:checked')?.value)) || variants[0];
      const productRoot = form.closest('[data-product-root]');
      productRoot.querySelector('[data-product-price]').textContent = money(variant.price);
      const compare = productRoot.querySelector('[data-product-compare]');
      if(compare) {compare.textContent = money(variant.compare_at_price); compare.hidden = !(variant.compare_at_price > variant.price);}
      const sale = productRoot.querySelector('.tl-sale-badge'); if(sale) sale.hidden = !(variant.compare_at_price > variant.price);
      const url = new URL(location.href); url.searchParams.set('variant',String(variant.id)); history.replaceState({},'',url); validate();
    };
    form.querySelectorAll('[name="id"]').forEach(input => input.addEventListener('change', changeVariant));
    [name,number,quantity].forEach(input => input.addEventListener('input', () => {error.hidden = true; input.removeAttribute('aria-invalid'); validate();}));
    form.querySelectorAll('[data-quantity-adjust]').forEach(control => control.addEventListener('click', () => {quantity.value = Math.min(99,Math.max(1,(Number(quantity.value)||1)+Number(control.dataset.quantityAdjust)));validate();}));
    form.addEventListener('submit', async event => {
      event.preventDefault(); if(busy) return;
      if(!validName() || !validNumber() || !validQuantity() || !variant.available) {
        error.textContent = !validName() ? 'Please enter a name with no more than 12 characters.' : !validNumber() ? 'Please enter a number from 0 to 99.' : !validQuantity() ? 'Please choose a valid quantity.' : 'This size is currently unavailable.';
        error.hidden = false;
        const invalid = !validName()?name:!validNumber()?number:quantity; invalid.setAttribute('aria-invalid','true'); invalid.focus(); validate(); return;
      }
      busy = true; error.hidden = true; validate();
      try {
        const response = await fetch((route.add || cartPath+'/add')+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:Number(quantity.value),properties:{Name:name.value.trim(),Number:number.value.trim()}}]})});
        const data = await response.json();
        if(!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'We couldn\'t add this item to your cart. Please try again.');
        document.dispatchEvent(new CustomEvent('trikolumo:cart-added',{detail:data}));
        await openCart(button);
      } catch(issue) {error.textContent = issue.message;error.hidden = false;} finally {busy = false;validate();}
    });
    validate();
  });
})();
